var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Logout')],_c('b-row',{staticClass:"m-10"},[_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('letters')],1),_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('merged-letters')],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }